import { createRequestTypes } from 'common/websocket-redux';

export const VIEWING_BULK_ADD_EMPLOYEE = 'employee/VIEWING_BULK_ADD_EMPLOYEE';

export const UPLOAD_CSV_REQUESTED = 'employee/UPLOAD_CSV_REQUESTED';

export const BULK_ADD_EMPLOYEES = createRequestTypes(
  'employee/BULK_ADD_EMPLOYEES',
);
